import {
  isDirectOnlyAdministrator,
  isDirectOnlyManagement
} from '../Utils/NotificationPreferences'

export const shouldRefreshAlerts = (user, event, mode) => {
  if (!user?._id || isDirectOnlyAdministrator(user, mode)) return false

  if (isDirectOnlyManagement(user, mode)) {
    return Boolean(event?.actionRoles?.includes(user.role))
  }

  return Boolean(event?.to?.includes(user.role))
}

export const shouldNotifyAlert = (user, event, mode) => {
  if (
    !user?._id ||
    user._id === event?.userId ||
    isDirectOnlyAdministrator(user, mode)
  ) {
    return false
  }

  if (isDirectOnlyManagement(user, mode)) {
    const actionRoles = event?.notifyActionRoles || event?.actionRoles
    return Boolean(actionRoles?.includes(user.role))
  }

  const notificationRecipients = event?.notifyTo || event?.to

  return Boolean(notificationRecipients?.includes(user.role))
}
